import { gql } from '@apollo/client';

export const HIGHLIGHTS_QUERY = gql`
  query {
    highlights {
      items {
        name
        link
        imageUrl
      }
    }
  }
`;

export interface HighlightsQueryData {
  highlights: {
    items: HighlightItem[];
  };
}

export interface HighlightItem {
  name: string;
  link: string;
  imageUrl: string;
}
